// Icones dos diferenciais: a pagina publica e a configuracao usam a mesma lista.
import { Award, Baby, Clock, Coffee, CreditCard, Scissors, Sparkles, SquareParking, Star, Wifi } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const HIGHLIGHT_ICONS: { key: string; label: string; Icon: LucideIcon }[] = [
    { key: 'scissors', label: 'Tesoura', Icon: Scissors },
    { key: 'star', label: 'Estrela', Icon: Star },
    { key: 'award', label: 'Prêmio', Icon: Award },
    { key: 'clock', label: 'Horário', Icon: Clock },
    { key: 'coffee', label: 'Café', Icon: Coffee },
    { key: 'wifi', label: 'Wi-Fi', Icon: Wifi },
    { key: 'parking', label: 'Estacionamento', Icon: SquareParking },
    { key: 'card', label: 'Pagamento', Icon: CreditCard },
    { key: 'kids', label: 'Crianças', Icon: Baby },
    { key: 'sparkles', label: 'Cuidado', Icon: Sparkles },
];

export const highlightIcon = (key?: string) =>
    (HIGHLIGHT_ICONS.find((icon) => icon.key === key) || HIGHLIGHT_ICONS[0]).Icon;
